import * as React from "react";
import ICurrencyElement from "./ICurrencyElement";
import { numberWithDelimiter } from "@features/utils/functions";
import { classNames } from "@features/utils/reactFunctions";
import { IGetNumberKey } from "@appInterfaces/general.types";
import { MAIN_CURRENCY, MAIN_CURRENCY_LABEL } from "@bundles/consts";
import Big from "big.js";

import * as style from "./CurrencyElementStyle.module.scss";
import * as general from "../../styles/general.module.scss";

export const decimalPlaces: IGetNumberKey = {
  usd: 2,
  [MAIN_CURRENCY]: 2,
  gbp: 2,
  aud: 2,
  eur: 2,
  chf: 2,
  drk: 2,
  pln: 2,
  bft: 4,
  usdt: 6,
};

export const CRYPTO_PLACES = 8;
export const INT_PLACES = 2;

const CurrencyElement: React.FunctionComponent<ICurrencyElement> = ({
  currency,
  value,
  bold,
  fixedTo,
  withCurrencyLabel = true,
  dataCy,
  upperCase = true,
}) => {
  const truncateValue = (value: string, position: number) =>
    value.slice(0, value.indexOf(".") + position);

  const numberedValue = Number(value);
  const stringedValue = new Big(value).toFixed(12);
  const fraction = numberedValue % 1;
  const numOfDecPlaces =
    fixedTo ||
    (!fraction
      ? INT_PLACES
      : decimalPlaces[currency?.toLowerCase()] || CRYPTO_PLACES);

  const preparedValue = truncateValue(stringedValue, numOfDecPlaces + 1);

  let valueBelowPrepared;
  if (Number(preparedValue) === 0 && numberedValue) {
    valueBelowPrepared = truncateValue(
      stringedValue,
      stringedValue.search("[1-9]")
    );
  }

  const displayCurrencyLabel = () => {
    const label = currency === MAIN_CURRENCY ? MAIN_CURRENCY_LABEL : currency;
    if (upperCase) {
      return label?.toUpperCase();
    }
    return label;
  };

  return (
    <span
      className={classNames(
        general.noSpaceWrap,
        style.currencyElement,
        bold && style.bold
      )}
      data-cy={dataCy || "currency-element"}
    >
      {numberWithDelimiter(valueBelowPrepared || preparedValue)}
      {withCurrencyLabel && <span>&nbsp;{displayCurrencyLabel()}</span>}
    </span>
  );
};

export default CurrencyElement;
